import { useState, useCallback } from 'react';

export enum DialogStep {
  CALL_OUTCOME = 'call_outcome',
  FOLLOW_UP_ACTIONS = 'follow_up_actions',
}

export const useDialogStep = () => {
  const [currentStep, setCurrentStep] = useState<DialogStep>(DialogStep.CALL_OUTCOME);

  const goToStep = useCallback((step: DialogStep) => {
    setCurrentStep(step);
  }, []);

  const goToNextStep = useCallback(() => {
    if (currentStep === DialogStep.CALL_OUTCOME) {
      setCurrentStep(DialogStep.FOLLOW_UP_ACTIONS);
    }
  }, [currentStep]);

  const goToPreviousStep = useCallback(() => {
    if (currentStep === DialogStep.FOLLOW_UP_ACTIONS) {
      setCurrentStep(DialogStep.CALL_OUTCOME);
    }
  }, [currentStep]);

  const resetStep = useCallback(() => {
    setCurrentStep(DialogStep.CALL_OUTCOME);
  }, []);

  return {
    currentStep,
    goToStep,
    goToNextStep,
    goToPreviousStep,
    resetStep,
  };
};
